import _ from 'lodash';

function filterLike(string) {
  let toFilter = string;

  if (!_.isString(string)) {
    if (_.isFinite(string)) {
      toFilter = `${string}`;
    }

    return null;
  }

  return toFilter
    ?.trim()
    ?.toLocaleLowerCase()
    ?.normalize('NFD')
    ?.replace(/[\u0300-\u036f]/g, '');
}

function applyFilter(filter, list, elementToString) {
  const filters = filterLike(filter)?.split(/\s+/g);

  if (filters.length > 0) {
    return list?.filter((element) =>
      filters.reduce(
        (acum, term) =>
          acum && filterLike(elementToString(element)).includes(term),
        true
      )
    );
  }

  return null;
}

export { filterLike, applyFilter };
